import React from "react";
import { useConfigContext } from "contexts/configContext";

export const LogoLogin = () => {
  const { visualConfig } = useConfigContext();
  const logoUrl = visualConfig?.logoLoginUrl || visualConfig?.logoUrl;

  if (!logoUrl) return null;

  return (
    <div className="login-logo mx-auto">
      <img src={logoUrl} alt="Logo" />
    </div>
  );
};
